// extracted by mini-css-extract-plugin
export default {"mainHeader":"LancetLaboratories_mainHeader__S+ZRm"};